export default __webpack_public_path__ + "static/media/Apple iPad 3 and 4.603a007b.png";